"use client";

import { Core } from "@faire/design-tokens";
import { createSVGIconV2 } from "@faire/web/slate/icons/lib/createSVGIconV2";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";

// Implemented using the icons from here: https://faire-wholesale.slack.com/archives/C08PZGMUC3Z/p1753300560248809
export const Close = createSVGIconV2(
  <>
    <path d="M2.5 2.5L21.5 21.5" stroke="currentColor" strokeLinecap="round" />
    <path d="M21.5 2.5L2.5 21.5" stroke="currentColor" strokeLinecap="round" />
  </>,
  { displayName: "Close", scalingFactor: 118 / 121 },
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: Core.icon.default,
    className: legacyIconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
